import { useContext } from 'react';
import * as React from 'react';
import styled from 'styled-components';
import { PostPurchaseContext } from '@/features/editor/widgets/post-purchase/context';
import { StylingComponentsGroup } from '@/features/editor/widgets/post-purchase/styling/group';
import { PostPurchaseTextualAreaInput } from '@/features/editor/widgets/post-purchase/inputs/textual-area';
import { ordinalNumber } from '@/utils/string-utils';
import { QuickEditTitle } from '@/features/editor/widgets/custom-widget/inputs/shared/radio-buttons';

export function PostPurchaseProductHeaders() {
  const { props, setProps } = useContext(PostPurchaseContext);
  const offerCount = props.settings.offersCount;

  const getKey = (idx: number) => `offer${idx + 1}`;

  return (
    <>
      {Array.from({ length: offerCount }).map((_, idx) => {
        const key = getKey(idx);

        return (
          <StylingComponentsGroup
            key={key}
            title={`${ordinalNumber(idx + 1)} Offer Text`}
          >
            <TextEditSection>
              <QuickEditTitle small>Header</QuickEditTitle>
              <PostPurchaseTextualAreaInput
                defaultValue={props?.content?.offersText?.[key]?.header}
                onChange={(p) =>
                  setProps((draft) => {
                    draft.content.offersText ??= {};
                    draft.content.offersText[key] ??= {};
                    draft.content.offersText[key].header = p;
                  })
                }
              />

              <QuickEditTitle small>Sub Header</QuickEditTitle>
              <PostPurchaseTextualAreaInput
                defaultValue={props?.content?.offersText?.[key]?.subHeader}
                onChange={(p) =>
                  setProps((draft) => {
                    draft.content.offersText ??= {};
                    draft.content.offersText[key] ??= {};
                    draft.content.offersText[key].subHeader = p;
                  })
                }
              />
            </TextEditSection>
          </StylingComponentsGroup>
        );
      })}
    </>
  );
}

const TextEditSection = styled.div`
  display: grid;
  grid-gap: 1rem;
`;
